/**
 * Team Member API Service
 * Task 5.2: Create Team Member API Client
 */

import { apiClient } from './client';
import type {
  TeamMemberWithUser,
  CreateTeamMemberRequest,
  UpdateTeamMemberRequest,
  GetTeamMembersResponse
} from '../../types/teamMember.types';

export const teamMemberService = {
  /**
   * Get all team members for a celebration
   */
  async getTeamMembers(celebrationId: number, includeInactive = false): Promise<TeamMemberWithUser[]> {
    const response = await apiClient.get<GetTeamMembersResponse>(
      `/celebrations/${celebrationId}/team-members`,
      {
        params: { includeInactive }
      }
    );
    return response.data.team_members;
  },

  /**
   * Get a specific team member
   */
  async getTeamMember(celebrationId: number, memberId: number): Promise<TeamMemberWithUser> {
    const response = await apiClient.get<TeamMemberWithUser>(
      `/celebrations/${celebrationId}/team-members/${memberId}`
    );
    return response.data;
  },

  /**
   * Add a new team member
   */
  async addTeamMember(
    celebrationId: number,
    data: CreateTeamMemberRequest
  ): Promise<TeamMemberWithUser> {
    const response = await apiClient.post<TeamMemberWithUser>(
      `/celebrations/${celebrationId}/team-members`,
      data
    );
    return response.data;
  },

  /**
   * Update a team member's role or status
   */
  async updateTeamMember(
    celebrationId: number,
    memberId: number,
    data: UpdateTeamMemberRequest
  ): Promise<TeamMemberWithUser> {
    const response = await apiClient.patch<TeamMemberWithUser>(
      `/celebrations/${celebrationId}/team-members/${memberId}`,
      data
    );
    return response.data;
  },

  /**
   * Remove a team member (set status to inactive)
   */
  async removeTeamMember(celebrationId: number, memberId: number): Promise<void> {
    await apiClient.delete(`/celebrations/${celebrationId}/team-members/${memberId}`);
  }
};
